/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import { closeModal } from 'helpers/actions'
import { useAppDispatch } from 'helpers/store'
import { XMarkIcon } from '@heroicons/react/24/solid'

const ModalScrollableClose = () => {
    const dispatch = useAppDispatch()

    const onCloseModalHandler = () => {
        dispatch(closeModal())
    }

    return (
        <button
            className={clsx(
                'ModalScrollableClose print:hidden bg-red-500 hover:bg-red-600 text-white sticky top-0 ml-auto z-100 rounded-bl-md rounded-tr-md p-2'
            )}
            onClick={onCloseModalHandler}
        >
            <XMarkIcon className={clsx('text-white hover:opacity-70 w-8')} />
        </button>
    )
}

export default ModalScrollableClose
